import { useConfigHelper } from '@ilteducation/config';
import type { RegisterEventsBody } from '@ilteducation/activity-stream-types';
import { useTokens } from '@ilteducation/ilt-auth';
import { captureSentryMessage } from '@ilteducation/sentry-vue3';

const { getApiUrl } = useConfigHelper();

const MAX_BATCH_SIZE = 100;

export const sendEventToActivityStream = async (data: RegisterEventsBody) => {
  const tokensStore = useTokens();
  let i = 0;
  do {
    const offset = MAX_BATCH_SIZE * i;
    const events = data.slice(offset, offset + MAX_BATCH_SIZE);

    const tokens = await tokensStore.getValidTokens();

    const accessToken = tokens ? tokens.accessToken : '';

    const hostname = window.location.hostname;
    const hostnameWithoutDots = hostname.replace(/\./g, '');

    const response = await fetch(`${getApiUrl('activity-stream')}/origin/${hostnameWithoutDots}/events`, {
      body: JSON.stringify(events),
      keepalive: true,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'POST',
    });

    if (!response.ok) {
      const responseBody = await response.json();

      captureSentryMessage('Failed to send events to activity stream', {
        responseBody: responseBody,
        status: response.status,
        hasWhatWeNeed: !!tokens && !!accessToken, // Avoid using "token" word in logs and fields since it will be filtered by Sentry
      });
    }

    i += 1;
  } while (data.length > MAX_BATCH_SIZE * i);
};
